/* eslint-disable no-console */

import {register} from 'register-service-worker';
import Notifications from './services/notification.service';

function reload(worker) {
  // Tells service-worker to load and skip waiting
  worker.postMessage({type: 'SKIP_WAITING'});
}

// Passes in waiting service worker
function notifyUserAboutUpdate(worker) {
  // If user selects "Reload" then go ahead and do it
  Notifications.updateToast(() => reload(worker));
}

if (process.env.NODE_ENV === 'production') {
  register(`${process.env.BASE_URL}service-worker.js`, {
    ready() {
      console.log(
        'App is being served from cache by a service worker.\n'
        + 'For more details, visit https://goo.gl/AFskqB'
      );
    },
    registered() {
      console.log('Service worker has been registered.');
    },
    cached() {
      console.log('Content has been cached for offline use.');
    },
    updatefound() {
      console.log('New content is downloading.');
    },
    updated(registration) {
      console.log('New content is available. Prompting user for reload.');
      notifyUserAboutUpdate(registration.waiting);
    },
    offline() {
      console.log('No internet connection found. App is running in offline mode.');
    },
    error(error) {
      console.error('Error during service worker registration:', error);
    }
  });

  // Refreshes other tabs on controller change
  let refreshing;
  navigator.serviceWorker.addEventListener('controllerchange', () => {
    if (refreshing) return;
    window.location.reload();
    refreshing = true;
  });
}
